<template>
  <div v-if="!facilityMonitoring?.length">
    <ProgressBar mode="indeterminate" style="height: 0.4em" />
  </div>
  <div class="horizontal-rows-container">
    <div v-for="facility in facilityMonitoring" :key="facility.facilityName + facility.flangeNumber" class="row-block">
      <img v-if="facility.imageIndex !== undefined && facility.imageIndex !== null" :title="facility.facilityName"
        :src="require(`/public/images/24x24/${facility.imageIndex}.png`)" width="19">
      <span class="field-tm name ml-1" :title="facility.facilityName" @click="openNewTab(facility)">{{
        facility.facilityName }}</span>
      <span class="field-tm flange" :title="facility.wellName">{{ facility.flangeNumber }}</span>
      <span class="field-tm value" title="Замер">{{ facility.outputValue }}</span>
      <span class="field-tm accum" title="Накоп замер">{{ facility.accumValueDay }}</span>
      <span class="field-tm date">{{ facility.datePropertyLong }}</span>
      <img :title="facility.eventTypeName" :src="require(`/public/images/24x24/${prepareImg(facility.groupId)}.png`)"
        width="19">
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import axios from 'axios';
const API_MONITORING = "kron.tm3.service-web-1.0/webresources/restservice/monitoring/GMB_BG_Well";
const EVENT_TO_IMG = {
  1: 51,
  2: 54,
  3: 51,
  4: 53,
  5: 52
};

const store = useStore();
const router = useRouter();

const intervalLoadMonitoring = ref(null);

const password = computed(() => store.getters.password);
const info = computed(() => store.getters.info);
const facilityMonitoring = computed(() => store.getters.monitoring);
const monitoringUpdate = computed(() => store.getters.monitoringUpdate);
const struct = computed(() => store.getters.struct);
const server = computed(() => store.getters.server);
const typeFormat = computed(() => store.getters.typeFormat);

const prepareImg = (event) => {
  return EVENT_TO_IMG[event] ? EVENT_TO_IMG[event] : 11;
};

const getFacility = (item) => {
  const result = { imageIndex: null, facilityTypeId: null, link: null };

  for (const element of struct.value) {
    if (item.facilityId === element.facility_id) {
      result.facilityTypeId = element.facility_type_id;
      result.imageIndex = element.image_index;
      result.link = {
        node_type_id: element.node_type_id,
        facility_id: element.facility_id,
        facility_type_id: element.facility_type_id,
      };
      element.children.forEach((child) => {
        if (child.parent_flange_no_min == item.flangeNumber) {
          result.imageIndex = element.image_index;
          result.facilityTypeId = element.facility_type_id;
          result.link = {
            node_type_id: element.node_type_id,
            facility_id: element.facility_id,
            facility_type_id: element.facility_type_id,
          };
        }
      });
    }
  }

  if (result.imageIndex === null) {
    for (const element of struct.value) {
      element.children.forEach((child) => {
        if (child.facility_id == item.facilityId) {
          result.imageIndex = child.image_index;
          result.facilityTypeId = child.facility_type_id;
          result.link = {
            node_type_id: child.node_type_id,
            facility_id: child.facility_id,
            facility_type_id: child.facility_type_id,
          };
        }
      });
    }
  }
  return result;
};

const prepareMonitoring = (data) => {
  return data.map(item => {
    const { imageIndex, facilityTypeId, link } = getFacility(item);
    return {
      facilityName: item.facilityName,
      wellName: item.descriptionOfTheWell,
      facilityTypeId,
      imageIndex: imageIndex ?? 12,
      link,
      flangeNumber: item.flangeNumber,
      datePropertyLong: item.datePropertyLong
        ? typeFormat.value(new Date(item.datePropertyLong), "timeHHMM")
        : item.lastActiveEventDate
          ? typeFormat.value(new Date(item.lastActiveEventDate), "timeHHMM")
          : null,
      accumValueDay: item.isAccumValue ? item.liquidSum : item.liquidTDay,
      outputValue: item.outputValue,
      eventTypeName: item.activeEvents?.length ? item.activeEvents[0].eventType?.name : '',
      groupId: item.activeEvents?.length
        ? item.activeEvents[0].eventType?.groupId
        : item.rowStyleLastActiveEvent
          ? item.rowStyleLastActiveEvent
          : null
    };
  });
};

const getValues = () => {
  const headers = {
    Authorization: "Basic " + btoa(info.value.login + ":" + password.value),
    "Content-Type": "application/zip",
  };
  const apiMonitoring = `${server.value("TM_MIDDLE")}${API_MONITORING}`;

  axios
    .get(apiMonitoring, { headers })
    .then((response) => {
      if (apiMonitoring === `${server.value("TM_MIDDLE")}${API_MONITORING}`) {
        store.dispatch('setMonitoring', prepareMonitoring(response.data));
      }
    })
    .catch((er) =>
      store.dispatch('addScriptLog', {
        message: `Ошибка получения мониторинга объектов TTMFacilitiesForm: ${er.response || er}`,
        facilityId: 0,
      })
    );
};
getValues();

const openNewTab = (facility) => {
  if (!facility.link) {
    store.commit("SET_ERROR", {
      er: `Ссылка для открытия объекта "${facility.name}" не найдена. Проверьте настройки объекта.`,
      source: ["TTMFacilitiesForm", "link"],
    });
    return;
  }
  const route = router.resolve({
    name: "form",
    params: facility.link,
    query: { form_class: 'TTMEventForm' }
  });
  window.open(route.href, "_blank");
};

onMounted(() => {
  intervalLoadMonitoring.value = setInterval(() => {
    getValues();
  }, monitoringUpdate.value * 1000);
});

onBeforeUnmount(() => {
  store.dispatch('setMonitoring', []);
  clearInterval(intervalLoadMonitoring.value);
});
</script>

<style lang="scss" scoped>
.horizontal-rows-container {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  //width: 1024px; // фиксированная ширина видимой области
  max-height: 800px;
  overflow-x: auto;
  overflow-y: hidden;
  align-content: flex-start;
  align-items: flex-start;
  gap: 1px;
  background: #fafafa;
  padding: 2px;
}

.row-block {
  width: 342px;
  height: 22px;
  display: flex;
  flex-direction: row;
  line-height: 22px;
  background: var(--surface-c);
  border-radius: 2px;
  padding: 2px 10px 2px 1px;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 0.1rem
}

.field-tm:not(:last-child) {
  border-right: 1px solid #ccc;
  padding-right: 4px;
  margin-right: 4px;
}

.field-tm {
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  //flex-shrink: 0; // чтобы поле не сжималось при нехватке места

  &.name {
    width: 100px;
    color: #1921B1;
  }

  &.flange {
    width: 24px;
  }

  &.value {
    width: 74px;
  }

  &.accum {
    width: 60px;
  }

  &.date {
    width: 50px;
  }
}
</style>